import { render, staticRenderFns } from "./bidNoticeSuccessful.vue?vue&type=template&id=23e4a0a8&scoped=true"
import script from "./bidNoticeSuccessful.vue?vue&type=script&lang=js"
export * from "./bidNoticeSuccessful.vue?vue&type=script&lang=js"
import style0 from "./bidNoticeSuccessful.vue?vue&type=style&index=0&id=23e4a0a8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e4a0a8",
  null
  
)

export default component.exports